// NEW PLACEHOLDER FOR BASE API URI - Not the final place, but it's unique across the Portal Pages.
var _baseApiUri = '';            // The Base URI for the API Service Calls - Loaded from Wordpress or sm.portal.local.js
var _currentPersonId = 0;        // The Currently Logged in Person ID - Loaded from WordPress or sm.portal.local.js
var _currentStudentId = 0;       // The Currently Logged in Student ID - Loaded from WordPress or sm.portal.local.js (will be 0 for a valid person that is not a student)
var _currentAdvisorId = 0;       // The Currently Logged in Student ID - Loaded from WordPress or sm.portal.local.js (will be 0 for a valid person that is not a student)
var _themeRelativePath = '';
var _uploadPath = '';            // Plugin folder
var _customerUploadPath = '';    // Uploads folder
var _ajaxUri = '';
var _isLogout = 'false';
var _registrationUri = '';
var _wpLocale = '';

(function ($, undefined) {
    var sm = window.sm = window.sm || {};

    if (typeof sm.portal === "undefined") {
        $.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.ui === "undefined") {
        $.extend(sm.portal, { ui: {} });
    }

    function initPage() {

        // bring in the WordPress parameters
        _currentPersonId = scriptParams.CurrentPersonId;
        _currentStudentId = scriptParams.CurrentStudentId;
        _currentAdvisorId = scriptParams.CurrentAdvisorId;
        _baseApiUri = scriptParams.BaseApiUrl;
        _themeRelativePath = scriptParams.ThemeRelativePath;
        _uploadPath = scriptParams.UploadPath;
        _customerUploadPath = scriptParams.CustomerUploadPath;
        _ajaxUri = scriptParams.AjaxUrl;
        _isLogout = scriptParams.IsLogout;
        _registrationUri = scriptParams.RegistrationUrl;
        _wpLocale = scriptParams.Locale;

        // Check for trailing / in the API URL
        if (!sm.portal.utility.isNullEmptyOrNothing(_baseApiUri)) {
            var lastChar = _baseApiUri.substr(_baseApiUri.length - 1);
            if (lastChar != '/') {
                _baseApiUri = _baseApiUri + '/';
            }
        }

        if (smapi.constant.accountDebugFlag) {
            console.log('Got WP Params, PersonId: ' + _currentPersonId + ', StudentId: ' + _currentStudentId + ', AdvisorId: ' + _currentAdvisorId + ', API: ' + _baseApiUri + ', RelThemePath: ' + _themeRelativePath + ', UploadPath: ' + _uploadPath + ', CustomerUploadPath: ' + _customerUploadPath + ', Registration: ' + _registrationUri + ', Locale: ' + _wpLocale);
            console.log('Got WP Params (2), IsLogout: ' + _isLogout);
            console.log('_ajaxUri: ' + _ajaxUri);
        }

        if (_isLogout == 'true') {
            // Call the Logout
            smapi.access.logout(_baseApiUri, function () { console.log('Logged Out!'); });

            // Clear the flag (reverse it)
            _isLogout = 'false';
        }

        $(document).ready(function () {
            $(document).ajaxSend(function (event, jqxhr, settings) {
                if (settings.url.toLowerCase().indexOf(_baseApiUri.toLowerCase()) === 0) {
                    jqxhr.setRequestHeader('__RequestVerificationToken', $('input[name=__RequestVerificationToken]').val());
                }
            });
        });

        // custom pre-event
        $(document).trigger('beforeSMInitPage');

        // Set localizalize Block UI Message
        $.blockUI.defaults.message = '<h1 role="alert">' + sm.portal.utility.getResourceValue('PleaseWait') + '</h1>';

        // flag elements to hide
        sm.portal.ui.hideElements();

        //Set Knockout validations defaults
        // THIS REALLY SLOWED EVERYTHING DOWN, it would stall every now and then on validation
        //ko.validation.configuration.grouping.deep = true;
        var knockoutValidationSettings = {
            messageTemplate: 'smFieldError'
        };

        // VERY IMPORTANT - TRUE, otherwise some custom validation may not be initialized
        ko.validation.init(knockoutValidationSettings, true);

        // any init page work goes here
        sm.portal.ui.readyPage();

        // custom post-event
        $(document).trigger('afterSMInitPage');
    }

    function readyPage() {

        // custom pre-event
        $(document).trigger('beforeSMReadyPage');

        // any ready page work goes here
        sm.portal.ui.optionalFeatureToggle();
        sm.portal.utility.flagMobile();
        sm.portal.ui.tabs();
        sm.portal.ui.itemMenu();
        sm.portal.ui.detailedList();
        sm.portal.ui.subDetailedList();
        sm.portal.ui.childOfSubDetailedList();
        sm.portal.ui.detailedTable();
        sm.portal.ui.comboBox();
        sm.portal.ui.loginWidgetOverride();
        sm.portal.ui.toggleSessionStartDate();
        sm.portal.ui.toggleSectionVisibility();
        sm.portal.ui.keywordSearch();
        //sm.portal.ui.createProfileImageEditor();
        unobtrusiveScrollTop();
        sm.portal.ui.simpleContainerToggle();
        sm.portal.utility.displayU4AboutDialog();

        // custom post-event
        $(document).trigger('afterSMReadyPage');

        /*
        * Accessibility
        * See sm.keyboardnav.js 
        */
        sm.portal.keyboardNav.widget();
        sm.portal.keyboardNav.aria(); // If this is placed in initPage, ul.detailedList > li will not receive attr('aria-...');
        sm.portal.keyboardNav.ariaLabel();
    }

    function resizePage() {

        // custom pre-event
        $(document).trigger('beforeSMResizePage');

        // any resize page work goes here
        sm.portal.ui.tableOverflow();
        sm.portal.ui.resizeLightbox();

        // custom post-event
        $(document).trigger('afterSMResizePage');

    }

    /*********************************************************************************/
    /*   Edit Profile Image Window                                                   */
    /*********************************************************************************/
    function createProfileImageEditor() {
        $('#profilePhoto, .work-text-content').not('[data-processed="true"]').click(function () {
            var bodyContent ='<p class="msg friendly active" id="informationMessage">' + sm.portal.utility.getResourceValue('ImageInformationMessage') + '</p>' +
                                '<p class="msg warning" id="errorMessage"></p>' +
                                '<div class="fieldGroup">' +
                                    '<div class="field" id="addFileDialogContent">' +
                                        '</span><input id="uploadedProfilePhoto" data-bind="event:{ change: validateUploadedFile}" style="background-color:#fff;padding:.5em;color:#000;border:solid 1px #dfdfdf;" accept="image/*" type="file"/>' +
                                    '</div>' +
                                '</div>';
            var buttonContent = '<button class="cancelBtn" onclick="sm.portal.ui.removeLightbox();" >' + sm.portal.utility.getResourceValue('Cancel') + '</button><button class="confirmBtn">' + sm.portal.utility.getResourceValue('OK') + '</button>';

            // show dialog
            sm.portal.ui.lightBox(sm.portal.utility.getResourceValue('AddFile'), bodyContent, ' smallDialog', null, null, buttonContent);
            validateUploadedFile();
            uploadFile();
        });
        $('#profilePhoto').attr('data-processed', true);
        $('.work-text-content').attr('data-processed', true);
    }
    function validateUploadedFile() {
        $(document).on('change', '#uploadedProfilePhoto', function () {
            var extension = $('#uploadedProfilePhoto').val().replace(/^.*\./, '').toLowerCase();
            var allowedFileExtensions = ['jpeg', 'jpg', 'png', 'bmp'];
            var size = $('#uploadedProfilePhoto')[0].files[0].size;
            var allowedSize = 2097152; //2MB

            if ($.inArray(extension, allowedFileExtensions) == -1) {
                hideInformationMessage();
                showErrorMessage(sm.portal.utility.getResourceValue('ImageExtensionErrorMessage'));
            }
            else if (size > allowedSize) {
                hideInformationMessage();
                showErrorMessage(sm.portal.utility.getResourceValue('ImageSizeErrorMessage'));
            }
            else {
                showInformationMessage();
                hideErrorMessage();
            }
        });
    }
    function uploadFile() {
        jQuery('.confirmBtn').click(function (e) {
            var url = _baseApiUri + 'api/studentprofile/UploadProfilePhoto';
            var file = $('#uploadedProfilePhoto')[0].files[0];
            var form = new FormData();
            form.append('uploadedProfilePhoto', file);

            $.ajax({
                type: "POST",
                url: url,
                contentType: false,
                data: form,
                headers: {
                    "x-api-version": '1'
                },
                processData: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (result) {
                    setProfilePhoto($('#uploadedProfilePhoto')[0]);
                    sm.portal.ui.removeLightbox();
                },
                error: function (xhr) {
                    showErrorMessage(xhr.responseJSON.error);
                }
            });
        });
    }

    function setProfilePhoto(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = function (e) {
                $('#profilePhoto').attr('src', e.target.result);
            }
            reader.readAsDataURL(input.files[0]);
        }
    }

    function showInformationMessage() {
        $('#informationMessage').addClass('active');
    }

    function hideInformationMessage() {
        $('#informationMessage').removeClass('active');
    }

    function showErrorMessage(errorMessage) {
        $('#errorMessage').addClass('active');
        $('#errorMessage').text(errorMessage);
        $('.confirmBtn').attr("disabled", true);
    }

    function hideErrorMessage() {
        $('#errorMessage').removeClass('active');
        $('.confirmBtn').attr("disabled", false);
    }

    /*********************************************************************************/
    /*   Upload UI Methods                                                           */
    /*********************************************************************************/
    function loadingIndicator(element) {

        var that = $(element);
        var main = that.closest('.uploadArea');
        var control = main.find('.uploadBox');
        var loadingIndicator = main.find('.loadingIndicator');
        var finalFile = main.find('div.fileThumb');

        // Hide upload control
        control.addClass('hidden');
        loadingIndicator.addClass('active');
    }

    function successIndicator(element, data, reenrollment) {
        var that = $(element);
        var main = that.closest('.uploadArea');
        var control = main.find('.uploadBox');
        var loadingIndicator = main.find('.loadingIndicator');
        var finalFile = main.find('div.fileThumb');
        var clearButton = main.find('button.resetUpload');
        var statusHidden = main.find('[name="DocStatus"]');
        var updateStatus = "#Status" + data.Payload.elementID;

        statusHidden.val(data.Payload.documentStatus);
        $(updateStatus).text(data.Payload.documentStatus);

        // Hide Loading Indicator
        loadingIndicator.removeClass('active');
        finalFile.addClass('active');

        if (reenrollment === undefined) {
            sm.portal.page.documentChecklist.doApplicationUpdate();
        }
    }

    function clearUpload(element) {
        var that = $(element);
        var main = that.closest('.uploadArea');
        var control = main.find('.uploadBox');
        var finalFile = main.find('div.fileThumb');
        var clearButton = main.find('button.resetUpload');

        clearButton.on('click', function () {
            finalFile.removeClass('active');
            control.removeClass('hidden');
        });
    }   

    /*********************************************************************************/
    /*   Tabs UI & Responsive Tab Methods                                            */
    /*********************************************************************************/
    function tabs() {
        $('[data-activate-tab]').not('[data-processed="true"]').each(function () {
            var that = $(this);
            var mySet = that.closest('.tabSet');
            var myTab = that.attr('data-activate-tab');

            // accessibility
            sm.portal.keyboardNav.keyboardControl(that);

            // Wire Up Show/Hide
            that.on('click', function (e) {

                // get rid of accessibility outline on click
                that.css('outline', 'none');

                e.stopPropagation();
                // Hide others
                mySet.find('.activeTab').removeAttr('active-tab').removeClass('activeTab');
                mySet.find('[data-tab-content]').removeAttr('active-tab').removeClass('activeTab').hide();

                // Show current
                that.addClass('activeTab').attr('active-tab', 'true');
                mySet.find('[data-tab-content="' + myTab + '"]').attr('active-tab', 'true').addClass('activeTab').fadeIn();
            }).attr('data-processed', true);

            // reset when leaving
            that.on('blur', function () {
                that.css('outline', '');
            });

            // Show Default or First Tab
            $('.tabSet').not('[data-processed="true"]').each(function () {
                var that = $(this);

                that.find('[data-tab-content]').first().addClass('activeTab').attr('active-tab', 'true').show();
                that.find('[data-activate-tab]').first().addClass('activeTab').attr('active-tab', 'true');

                that.attr('data-processed', true);
            });

            // might as well do responsive tab init here
            // This isn't ready for portal primetime yet.  Working in Admin, but needs to be tweaked for portal
            // eventually merge back to this file
            // until then - do it in prototype.widget first
            //sm.portal.ui.responsiveTabs(mySet);

            if (!mySet.is('[data-not-responsive]')) {
                sm.portal.ui.responsiveTabs(mySet);
            }
        });
    }

    function responsiveTabs(tabSet) {

        // gather elements
        var that = tabSet.length > 0 ? $(tabSet) : $('.tabSet');
        var tabWrapper = that.find('.tabWrapper');
        var tabs = tabWrapper.find('[data-activate-tab]');

        // Ensure we have all we need, otherwise, just log it
        if (that.length == 0 || tabWrapper.length == 0 || tabs.length == 0) {
            //console.log('Something wrong with responsive tab wiring');
            return false;
        }

        else {
            var actualTabWidth = sm.portal.ui.getTotalTabWidth(that);
            var totalWidth = 0;
            var resizeTimeout;

            // check overflow on readyPage
            sm.portal.ui.checkTabOverflow(that, tabWrapper, actualTabWidth);

            // on each resize
            $(window).on('resize', function () {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(function () {
                    sm.portal.ui.checkTabOverflow(that, tabWrapper, actualTabWidth);
                }, 50);
            });
        }
    }

    function getTotalTabWidth(tabset) {
        var that = tabset.length > 0 ? $(tabset) : $('.tabSet');
        var tabWrapper = that.find('.tabWrapper');
        var tabs = tabWrapper.find('[data-activate-tab]');
        var totalTabWidth = 0;

        tabs.each(function () {
            //totalTabWidth += $(this).css('display', 'inline-block').outerWidth(true);
            totalTabWidth += $(this).getHiddenDimensions(true).outerWidth; // better method for getting width of hidden items
        })
        return totalTabWidth;
    }

    function checkTabOverflow(tabBar, tabWrapper, actualTabWidth) {
        if (tabWrapper.getHiddenDimensions(true).innerWidth < actualTabWidth) {
            tabBar.addClass('responsiveTabs');
            // wire up tab menu - pass in top level tabBar
            sm.portal.ui.responsiveTabMenu(tabBar, tabWrapper);
        }
        else {
            tabBar.removeClass('responsiveTabs');
        }
    }

    function responsiveTabMenu(tabBar, tabWrapper) {
        var inactiveTabs = tabWrapper.children('[data-activate-tab]').not('.activeTab');
        var tabMenuBtn = tabBar.find('.tabMenuBtn');
        var tabDropMenu = tabBar.find('.tabDropMenu');

        tabMenuBtn.not('[data-tabmenubtn-processed="true"]').on('click', function () {
            if (!$(this).hasClass('active')) {
                tabDropMenu.find("[data-activate-tab].activeTab").removeClass("activeTab");
                $(this).addClass('active');
                jQuery('#blockTabMenu').css({ 'max-height': (jQuery("#blockTabCourses")[0].offsetHeight + 'px') });
                jQuery('#blockTabMenu').css({ 'overflow-y': 'auto', 'z-index' : 1, 'min-height' : '150px' });
                // just to prevent theme footer from cutting off menu (portal block registration)
                $(this).closest('section').css('overflow', 'visible');

                sm.portal.ui.responsiveTabSync(tabBar, $(this));
                tabDropMenu.show();

            }
            else {
                $(this).removeClass('active');
                tabDropMenu.hide();

                // just to prevent theme footer from cutting off menu (portal block registration)
                $(this).closest('section').removeAttr('style');
            }
        });
        tabMenuBtn.attr('data-tabmenubtn-processed', true);
    }

    function responsiveTabSync(tabBar, tabMenuBtn) {
        var activeTab = tabBar.find('[data-activate-tab].activeTab').attr('data-activate-tab'); // this should always be fresh to check for newly added tabs
        var tabDropMenu = tabBar.find('.tabDropMenu');
        var tabDropMenuTabs = tabDropMenu.find('[data-activate-tab]');

        // sync active tab into dropdown
        $('.tabDropMenu [data-activate-tab="' + activeTab + '"]').addClass('activeTab');


        tabDropMenuTabs.not('[drop-tab-wired="true"]').each(function () {
            $(this).on('click', function () {
                activeTab = $(this).attr('data-activate-tab');
                // update droptabs
                tabDropMenuTabs.removeClass('activeTab');
                $(this).addClass('activeTab');

                //update core tabbar
                tabBar.find('[data-activate-tab].activeTab').removeClass('activeTab');
                tabBar.find('[data-activate-tab="' + activeTab + '"]').addClass('activeTab');

                tabDropMenu.hide();
                tabMenuBtn.removeClass('active');

            });

            $(this).attr('drop-tab-wired', true);
        });
    }



    /*********************************************************************************/
    /*   API Lightbox Model Dialog Methods                                           */
    /*********************************************************************************/
    function lightBox(title, content, baseClass, callback, hideContentOnClose, footerContent, closeCallback, noModalHeight, noModalContentHeight, id, focusableElement) {
        // Portal Responsive Lightbox Custom Code
        // Generic Portal Lightbox - Pass in Title/Content

        var originalPosition = $('[data-original-position]').length > 0 ? $('[data-original-position]').attr('data-original-position') : $(window).scrollTop();
        var base = baseClass == null ? "" : baseClass;
        var setModalHeight = (noModalHeight == 'true' || noModalHeight == true) ? 'data-no-auto-height' : '';
        var setModalContentHeight = (noModalContentHeight == 'true' || noModalContentHeight == true) ? 'data-no-auto-height' : '';
        var overlay = $('<div class="smOverlay"></div>');
        //we always want the About Box to be at the top
        if (!sm.portal.utility.isNullEmptyOrNothing(id) && id == "AboutBox") {
            overlay.attr("style", "z-index: 1000");
        }

        //dummy anchor to get focus
        var modal = $('<div role="dialog" aria-modal="true" class="smModal ' + base + '"' + setModalHeight + ' id="' + id + '"><div class="smModalHeader"><h2>' + title + '</h2><button aria-label="Close" class="smModalClose simpleX">X</button></div><div class="smModalContent"' + setModalContentHeight + '></div><div class="clearfix"></div></br><span tabindex="0" class="sr-only">' + title + ' Dialog </span>');

        // set or re-set the original position value
        $('body').attr('data-original-position', originalPosition);

        // only create footer if we have footer content
        if (!sm.portal.utility.isNullEmptyOrNothing(footerContent)) {
            footerContent = $('<div class="smModalFooter"></div>)').append(footerContent);
            $(modal).find('.smModalContent').after(footerContent);
        }



        // freeze the dom
        sm.portal.theme.freezeContent();

        // Append overlay and grow
        overlay.appendTo('body').height($(window).height() + 'px');
        // Add the content
        modal.find('.smModalContent').html(content);
        // Append and set heights
        //some cases there can be two divs so calling last picks the correct one
        modal.appendTo('.smOverlay').last().addClass('active');
        // wire up closing
        //if there is an id we need to pass it in, if two lightboxes are up it will close both
        sm.portal.ui.closeLightbox(id, closeCallback, originalPosition, focusableElement);

        // execute callback if exists
        if (!sm.portal.utility.isNullOrEmpty(callback) && typeof callback === 'function') {
            eval(callback());
        }

        sm.portal.ui.resizeLightbox();
        /*
         * Accessibility
         * See sm.keyboardnav.js

         * modalNav()
         * Give first tabbable element in modal focus and keep tabbing focus within modal.
        */
        sm.portal.keyboardNav.modalNav();
    }
    function lightBoxLogout(title, content, baseClass, callback, hideContentOnClose, footerContent, closeCallback, noModalHeight, noModalContentHeight, id, focusableElement) {
        // Portal Responsive Lightbox Custom Code
        // Generic Portal Lightbox - Pass in Title/Content

        var originalPosition = $('[data-original-position]').length > 0 ? $('[data-original-position]').attr('data-original-position') : $(window).scrollTop();
        var base = baseClass == null ? "" : baseClass;
        var setModalHeight = (noModalHeight == 'true' || noModalHeight == true) ? 'data-no-auto-height' : '';
        var setModalContentHeight = (noModalContentHeight == 'true' || noModalContentHeight == true) ? 'data-no-auto-height' : '';
        var overlay = $('<div id="Logout-Box" class="smOverlay idelLogoutPopup"></div>');
        //we always want the About Box to be at the top
        if (!sm.portal.utility.isNullEmptyOrNothing(id) && id == "AboutBox") {
            overlay.attr("style", "z-index: 1000");
        }

        //dummy anchor to get focus
        var modal = $('<div role="dialog" aria-modal="true" class="smModal ' + base + '"' + setModalHeight + ' id="' + id + '"><div class="smModalHeader"><h2>' + title + '</h2></div><div class="smModalContent"' + setModalContentHeight + '></div><div class="clearfix"></div></br><span tabindex="0" class="sr-only">' + title + ' Dialog </span>');

        // set or re-set the original position value
        $('body').attr('data-original-position', originalPosition);

        // only create footer if we have footer content
        if (!sm.portal.utility.isNullEmptyOrNothing(footerContent)) {
            footerContent = $('<div class="smModalFooter"></div>)').append(footerContent);
            $(modal).find('.smModalContent').after(footerContent);
        }

        // freeze the dom
        sm.portal.theme.freezeContent();
        // Append overlay and grow
        overlay.appendTo('body').height($(window).height() + 'px');
        // Add the content
        modal.find('.smModalContent').html(content);
        // Append and set heights
        //some cases there can be two divs so calling last picks the correct one
        modal.appendTo('.smOverlay').last().addClass('active');
        // wire up closing
        //if there is an id we need to pass it in, if two lightboxes are up it will close both
        sm.portal.ui.closeLightbox(id, closeCallback, originalPosition, focusableElement);

        // execute callback if exists
        if (!sm.portal.utility.isNullOrEmpty(callback) && typeof callback === 'function') {
            eval(callback());
        }

        sm.portal.ui.resizeLightbox();
        /*
         * Accessibility
         * See sm.keyboardnav.js

         * modalNav()
         * Give first tabbable element in modal focus and keep tabbing focus within modal.
        */
        sm.portal.keyboardNav.modalNav();
    }

    function sponsorLightBox(title, content, baseClass, callback, hideContentOnClose, footerContent, closeCallback, noModalHeight, noModalContentHeight, id, focusableElement) {
        // Portal Responsive Lightbox Custom Code
        // Generic Portal Lightbox - Pass in Title/Content

        var originalPosition = $('[data-original-position]').length > 0 ? $('[data-original-position]').attr('data-original-position') : $(window).scrollTop();
        var base = baseClass == null ? "" : baseClass;
        var setModalHeight = (noModalHeight == 'true' || noModalHeight == true) ? 'data-no-auto-height' : '';
        var setModalContentHeight = (noModalContentHeight == 'true' || noModalContentHeight == true) ? 'data-no-auto-height' : '';
        var overlay = $('<div class="smOverlay"></div>');
        //we always want the About Box to be at the top
        if (!sm.portal.utility.isNullEmptyOrNothing(id) && id == "AboutBox") {
            overlay.attr("style", "z-index: 1000");
        }

        //dummy anchor to get focus
        var modal = $('<div role="dialog" aria-modal="true" class="smModal ' + base + '"' + setModalHeight + ' id="' + id + '"><div class="smModalHeader"><h2>' + title + '</h2><button aria-label="Close" class="smModalClose simpleX">X</button></div><div class="smModalContent"' + setModalContentHeight + '></div><div class="clearfix"></div></br><span tabindex="0" class="sr-only">' + title + ' Dialog </span>');

        // set or re-set the original position value
        $('body').attr('data-original-position', originalPosition);

        // only create footer if we have footer content
        if (!sm.portal.utility.isNullEmptyOrNothing(footerContent)) {
            footerContent = $('<div class="smModalFooter"></div>)').append(footerContent);
            $(modal).find('.smModalContent').after(footerContent);
        }



        // freeze the dom
        sm.portal.theme.freezeContent();

        // Append overlay and grow
        overlay.appendTo('body').height($(window).height() + 'px');
        // Add the content
        modal.find('.smModalContent').html(content);
        // Append and set heights
        //some cases there can be two divs so calling last picks the correct one
        modal.appendTo('.smOverlay').last().addClass('active');
        // wire up closing
        //if there is an id we need to pass it in, if two lightboxes are up it will close both
        sm.portal.ui.closeSponsorLightbox(id, closeCallback, originalPosition, focusableElement);

        // execute callback if exists
        if (!sm.portal.utility.isNullOrEmpty(callback) && typeof callback === 'function') {
            eval(callback());
        }

        sm.portal.ui.resizeLightbox();
        /*
         * Accessibility
         * See sm.keyboardnav.js

         * modalNav()
         * Give first tabbable element in modal focus and keep tabbing focus within modal.
        */
        sm.portal.keyboardNav.modalNav();
    }

    // Lightbox Closing by 'Esc' or 'Close' button within overlay
    function closeSponsorLightbox(which, cb, originalPos, focusableElement) {

        which = ($('#' + which).length > 0 && $('#' + which).is('.smModal')) ? $('#' + which) : $('.smModal.active');

        originalPos = (typeof originalPos == 'number') ? originalPos : $('[data-original-position]').attr('data-original-position');

        // with escape key
        $(document).one('keyup', function (e) {
            if (e.keyCode == 27) {
                which.closest('.smOverlay').remove();

                sm.portal.theme.unfreezeContent();
                sm.portal.theme.restorePosition(originalPos);
            }

            // execute callback if exists
            if (cb != null && cb != '' && cb != 'undefined') {
                sm.portal.ui.executeFunctionByName(cb, window, null);
            }
        });

        // with close button
        which.find(".smModalClose,[data-close-lightbox]").on('click keypress', function (cb) {

            if (event.type === "click" || (event.type === "keypress" && (event.which == 13 || event.which == 32))) {
                which.closest('.smOverlay').remove();

                sm.portal.theme.unfreezeContent();
                sm.portal.theme.restorePosition(originalPos);

                // execute close callback
                if (cb != null && cb != '' && cb != 'undefined') {
                    sm.portal.ui.executeFunctionByName(cb, window, null);
                }
                
            }
        });

    }

    // Lightbox reset content
    function loadOrCreateLightbox(title, content, baseClass, callback, hideContentOnClose, footerContent, closeCallback, noModalHeight, noModalContentHeight, id) {

        // Check for existing lightbox
        var matches = $("div.smModal.active");
        if (matches.length == 0) {

            // Generate a new lightbox
            return lightBox(title, content, baseClass, callback, hideContentOnClose, footerContent, closeCallback, noModalHeight, noModalContentHeight, id);
        }

        // replace the content
        $(matches[0]).find("div.smModalContent").html(content);

        // replace the footer
        if (!sm.portal.utility.isNullOrEmpty(footerContent)) {
            $(matches[0]).find("div.smModalFooter").html(footerContent);
        }
    }

    // Lightbox resizing
    function resizeLightbox() {
        $('.smOverlay').height($(window).height() + 'px');
        $('.smModal').not('[data-no-auto-height]').height(($(window).height() /* - 60 */) + 'px');
        $('.smModalContent').not('[data-no-auto-height]').height($(window).height() - $('.smModalHeader').height() + 'px');
    }

    // Lightbox Closing by 'Esc' or 'Close' button within overlay
    function closeLightbox(which, cb, originalPos, focusableElement) {

        which = ($('#' + which).length > 0 && $('#' + which).is('.smModal')) ? $('#' + which) : $('.smModal.active');

        originalPos = (typeof originalPos == 'number') ? originalPos : $('[data-original-position]').attr('data-original-position');

        // with escape key
        $(document).one('keyup', function (e) {
            if (e.keyCode == 27) {
                which.closest('.smOverlay').remove();

                sm.portal.theme.unfreezeContent();
                sm.portal.theme.restorePosition(originalPos);
            }

            // execute callback if exists
            if (cb != null && cb != '' && cb != 'undefined') {
                sm.portal.ui.executeFunctionByName(cb, window, null);
            }
        });

        // with close button
        which.find(".smModalClose,[data-close-lightbox]").on('click keypress', function (cb) {

            if (event.type === "click" || (event.type === "keypress" && (event.which == 13 || event.which == 32))) {
                which.closest('.smOverlay').remove();

                sm.portal.theme.unfreezeContent();
                sm.portal.theme.restorePosition(originalPos);

                // execute close callback
                if (cb != null && cb != '' && cb != 'undefined') {
                    sm.portal.ui.executeFunctionByName(cb, window, null);
                }
                if (!sm.portal.utility.isNullOrEmpty(focusableElement) && focusableElement.length > 0)
                    focusableElement.focus();
                else
                sm.portal.keyboardNav.giveContentFocus('.smContentArea');
            }
        });



    }

    // Remove lightbox completely from the DOM
    function removeLightbox(element) {
        $('.smOverlay,.smModal').remove();
        // Unfreeze the dom for iOS
        sm.portal.theme.unfreezeContent();
        if (!sm.portal.utility.isNullOrEmpty(element) && element.length > 0)
            element.focus();
        else
        sm.portal.keyboardNav.giveContentFocus('.smContentArea');
    }



    /*********************************************************************************/
    /*   Element Decoration Methods                                                  */
    /*********************************************************************************/
    function syntaxHighlight(json) {
        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            var cls = 'number';
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = 'key';
                } else {
                    cls = 'string';
                }
            } else if (/true|false/.test(match)) {
                cls = 'boolean';
            } else if (/null/.test(match)) {
                cls = 'null';
            }
            return '<span class="' + cls + '">' + match + '</span>';
        });
    }

    function hideElements() {
        if ($('.smContentArea.u4HideNav').length > 0) {
            $('.smContentArea.u4HideNav').removeClass('u4HideNav');
            $('body').addClass('u4HideNav');
        }

        if ($('.smContentArea.u4HideFooter').length > 0) {
            $('.smContentArea.u4HideFooter').removeClass('u4HideFooter');
            $('body').addClass('u4HideFooter');
        }
    }



    /*********************************************************************************/
    /*   Standard Record Paging View Model                                           */
    /*********************************************************************************/
    function RecordPagingViewModel() {

        // Pager Data Points
        // Current Page Index
        this.Page = ko.observable();
        // Current Page Number (Index + 1, handles 0-based indexes)
        this.PageNumber = ko.computed(function () {
            return (parseInt(this.Page()) + 1);
        }, this);
        // Total count of pages
        this.PageCount = ko.observable();
        // Page size
        this.PageSize = ko.observable(10);
        // Total Records returned
        this.RecordCount = ko.observable();

        // Read-Only display for user - "Showing page X of X, X records total"
        this.CounterDisplay = ko.computed(function () {
            return "Showing page " + this.PageNumber() + " of " + this.PageCount() + ", " + this.RecordCount() + " total records.";
            
        }, this);

        // The URL used to retrieve the data to be paged        
        this.DataSourceUrl = ko.observable();

        // The function that fires when data is loaded (i.e. how do we display the data, and the pager)
        this.DataResponseFunc = function (container, pagingContent) {

        };
                
        // Button Enable Calcuated functions - enable/disable navigation buttons according to the rules
        this.FirstPageNavDisabled = ko.computed(function () {
            if (this.Page() == 0)
                return true;
            return false;
        }, this);
        this.LastPageNavDisabled = ko.computed(function () {
            if (this.PageNumber() >= this.PageCount())
                return true;
            return false;
        }, this);
        this.PreviousPageNavDisabled = ko.computed(function () {
            return !(this.Page() > 0);
        }, this);
        this.NextPageNavDisabled = ko.computed(function () {
            return !(this.PageNumber() < this.PageCount());
        }, this);

        // Binds the click events to the navigation buttons
        this.BindNavigation = function () {
            // Bind the Next/Prev/First/Last buttons
            $('[data-paging-nav="true"]').not('[data-paging-processed="true"]').each(function () {
                var that = $(this);
                that.on('click', function () {

                    // Update the page based on the Direction the button indicates
                    // If we wanted to do a "Select the Page", we could modify this to accept an integer, and pass that (or another binding)
                    var dir = that.attr('data-paging-nav-dir');
                    switch (dir) {
                        case "firstPage":
                            self.Page(0);
                            break;
                        case "previousPage":
                            self.Page(self.Page() - 1);
                            break;
                        case "nextPage":
                            self.Page(self.Page() + 1);
                            break;
                        case "lastPage":
                            self.Page(self.PageCount() - 1);
                            break;
                    }

                    var closeButton = jQuery('.smModalClose');
                    if (!sm.portal.utility.isNullOrEmpty(closeButton))
                        closeButton.focus();
                    self.GetData();
                });
                that.attr('data-paging-processed', true);
            });
        };

        // Standard PageReady function, calls on page refresh
        this.PageReady = function () {
            self.BindNavigation();
        };

        // Retrieves the data being paged.
        this.GetData = function () {

            $.blockUI();

            $.ajax({
                url: self.DataSourceUrl() + '&page=' + self.Page() + '&pageSize=' + self.PageSize(),
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    // Load the container
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    if (data.Status == 'success') {

                        // Set the internal Paging Data points (returned every getdata call)
                        self.RecordCount(container.Payload.PagingData.RecordCount);
                        self.PageCount(container.Payload.PagingData.PageCount);

                        // Render the Paging Content
                        var temp = $("<div>");
                        ko.applyBindingsToNode(temp[0], { template: { "name": "RecordPagingTemplate", "data": self } });
                        var html = temp.html();
                        temp.remove();

                        // Call the handler function
                        if (self.DataResponseFunc != null) {
                            self.DataResponseFunc(container, html);
                        }
                    }
                    else if (data.Status == 'validationerror') {
                        self.HandleError(container.ValidationTitle, container.ValidationMessages);
                    } else if (data.Status == 'error') {
                        self.HandleError(container.ValidationTitle, container.ValidationMessages);
                    }

                    // Unblock and page-ready for binding
                    $.unblockUI();
                    self.PageReady();
                },
                error: function (jqXHR, exception) {
                    viewModel.HandleError(exception);
                    $.unblockUI();
                }
            });
        };

        // Error Handling
        this.HandleError = function (title, messages) {
            this.IsError(true);
            this.ErrorMessages(messages);
            if (sm.portal.utility.isNullOrEmpty(title)) {
                self.ErrorHeader(sm.portal.utility.getResourceValue('ThereWasAnError'));
            } else {
                self.ErrorHeader(title);
            }
        };
        this.ErrorHeader = ko.observable();
        this.ErrorMessages = ko.observableArray();
        this.IsError = ko.observable();

        // Self-Identification
        var self = this;
        return self;
    };



    /*********************************************************************************/
    /*   Miscellaneous UI Methods                                                    */
    /*********************************************************************************/
    // TABLE OVERFLOW DETECTION
    // NOT SURE WHERE I INTENDED THIS TO BE USED, BUT WAY TOO INVASIVE - SCOPED MORE NARROWLY (using added class of 'responsiveTable') NOW TO BE APPLIED WHERE NEEDED
    function tableOverflow() {
        $('table.portalDefault.responsiveTable').each(function () {
            var that = $(this);
            var mainParent = that.closest('.flexWidget');
            var myWidth = that.outerWidth();
            var parentWidth = that.closest('.widgetContent').outerWidth();
            var phoneView = mainParent.find('.isPhone');
            var defaultView = mainParent.find('.notPhone');

            if (myWidth > parentWidth) {
                phoneView.show();
                defaultView.hide();
            }
            else {
                defaultView.show();
                phoneView.hide();
            }
        });
    }

    function optionalFeatureToggle() {
        //@TODO - This function will need to be modified once more optional features need to be added to Student Portal.
        $.blockUI();
        if (sm.portal.utility.isAPASFeatureEnabled()) {
            $('.EuOptionalFeatureShow').hide();
            $('.EuOptionalFeatureHide').show();
            $('.UkOptionalFeatureShow').hide();
            $('.UkOptionalFeatureHide').show();
            $('.ApasOptionalFeatureShow').show();
            $('.ApasOptionalFeatureHide').hide();

        }
        else if (sm.portal.utility.isEUFeatureEnabled()) {
            $('.UkOptionalFeatureShow').hide();
            $('.UkOptionalFeatureHide').show();
            $('.EuOptionalFeatureShow').show();
            $('.EuOptionalFeatureHide').hide();
            $('.ApasOptionalFeatureShow').hide();
            $('.ApasOptionalFeatureHide').show();

        }
        else if (sm.portal.utility.isUKFeatureEnabled()) {
            $('.EuOptionalFeatureShow').hide();
            $('.EuOptionalFeatureHide').show();
            $('.UkOptionalFeatureShow').show();
            $('.UkOptionalFeatureHide').hide();
            $('.ApasOptionalFeatureShow').hide();
            $('.ApasOptionalFeatureHide').show();

        }
        else {
            $('.EuOptionalFeatureShow').hide();
            $('.EuOptionalFeatureHide').show();
            $('.UkOptionalFeatureShow').hide();
            $('.UkOptionalFeatureHide').show();
            $('.ApasOptionalFeatureShow').hide();
            $('.ApasOptionalFeatureHide').show();
        }
        $.unblockUI();
    }

    // Widget Item Menu
    function itemMenu() {
        $('.flexWidget .itemMenu').not('[data-processed="true"]').each(function () {
            var that = $(this);
            var myButton = that.find('.menuIcon');
            var myMenu = that.find('ul');

            myButton.on('click', function () {
                if (myMenu.hasClass('active')) {
                    myMenu.removeClass('active');
                }
                else {
                    myMenu.addClass('active');
                }
            });
            that.attr('data-processed', true);
        });
    }

    function uploadDocument(event, element) {
        event.preventDefault();

        if (!sm.portal.utility.isNullOrEmpty(element)) {
            if (event.which == 13) {
                jQuery(element).trigger('click');
            }
        }
    }

    // Detailed List - Special for KO Rewire
    function detailedList() { // Called in readyPage()
        $('ul.detailedList > li').each(function () {
            var that = $(this);

            if (!that.is('[data-processed]')) {
                sm.portal.ui.renderDetailedListItem(that);
            }

            else if (that.is('[data-processed]') && that.is('[data-ko-rewire]')) {
                that.removeAttr('data-processed');
                sm.portal.ui.renderDetailedListItem(that);
            }
        });
    }

    function subDetailedList() {
        $('ul.subDetailedList > li').each(function () {
            var that = $(this);

            if (!that.is('[data-processed]')) {
                sm.portal.ui.renderDetailedListItem(that);
            }

            else if (that.is('[data-processed]') && that.is('[data-ko-rewire]')) {
                that.removeAttr('data-processed');
                sm.portal.ui.renderDetailedListItem(that);
            }
        });
    }

    function childOfSubDetailedList() {
        $('ul.childOfSubDetailedList > li').each(function () {
            var that = $(this);

            if (!that.is('[data-processed]')) {
                sm.portal.ui.renderDetailedListItem(that);
            }

            else if (that.is('[data-processed]') && that.is('[data-ko-rewire]')) {
                that.removeAttr('data-processed');
                sm.portal.ui.renderDetailedListItem(that);
            }
        });
    }

    // Heavy Lifting for Detailed List Construct
    function renderDetailedListItem(that) {
        if ($(that).is('li')) {
            var myButton = that.find('.detailsIcon');
            var myList = that.closest('ul.detailedList');
            var itemDetails = that.find('.itemDetails');
            var hasDetails = (itemDetails.length > 0);
            var childButtons = that.find('button');
            var childLinks = that.find('[href]');
            var otherClickExclusions = that.find('[data-exclude-click]');
            var isSingleOpen = myList.is('[data-singleopen]');
            var tabSet = that.find('.tabSet');
            var hasTabs = (tabSet.length > 0);
            var childCheckbox = that.find('input:checkbox');

            // unbind click just in case something got through
            that.off('click');

            // unbind keyboard control to ensure no double wiring
            that.off('keydown');

            //keyboard accessibility for document upload 
            jQuery(that).find('.uploadBox').on('keypress', function (event) {
                event.stopImmediatePropagation();
                if (event.which == 13) {
                    jQuery(this).trigger('click');
                }
            });

            // fix for icons within disabled buttons propagating the click
            childButtons.each(function () {
                if ($(this)[0].hasAttribute('disabled')) {
                    $(this).children('.icon').on('click', function (e) {
                        e.stopPropagation();
                    });
                }
            });

            // prevents keydown from activating parent
            childButtons.on('keydown', function (e) {
                e.stopPropagation();
            });

            // Prevent Propagation of Internal Button Clicks
            childButtons.on('click', function (e) {
                e.stopPropagation();
            });

            childLinks.on('click keydown', function (e) {             
                e.stopPropagation();
            });

            otherClickExclusions.on('click', function (e) {
                e.stopPropagation();
            });

            childCheckbox.on('keydown click', function (event) {
                if (event.type === "click" || (event.type === "keydown" && (event.which == 13 || event.which == 32))) {
                    event.stopPropagation();
                }
            });

            // If it has details, wire up the click event to show them
            if (hasDetails) {
                that.css('cursor', 'default').attr('data-hasdetails', true);
                myButton.css('cursor', 'pointer');
                
                // initialize aria expanded state
                that.attr('aria-expanded', false);

                //setting aria expanded when list state did not change
                if (that.hasClass('detailsShowing') && myButton.hasClass('hide')) {
                    that.attr('aria-expanded', true);
                }

                myButton.off('click keypress');

                $(that).on('keydown', function (e) {
                    if (e.which === 32)  // the space key code
                    {
                        myButton.click();
                        return false;
                    }
                });

                // if only one at a time
                if (isSingleOpen) {

                    myButton.on('click keypress', function (event) {
                        if (event.type === "click" || (event.type === "keypress" && (event.which == 13 || event.which == 32))) {
                            // close/revert others
                            myList.find('[data-hasdetails]').not(myButton.closest('li')).each(function () {
                                var that = $(this);
                                var innerButton = that.find('.detailsIcon');
                                var itemDetails = innerButton.next('.itemDetails');

                                // toggle aria state
                                that.attr('aria-expanded', false);

                                innerButton.removeClass('hide').addClass('show');
                                itemDetails.removeClass('active');
                                that.removeClass('detailsShowing');
                            });

                            // Hide the item as needed
                            if (myButton.hasClass('hide')) {

                                // toggle aria state
                                that.attr('aria-expanded', true);

                                myButton.removeClass('hide').addClass('show');
                                itemDetails.removeClass('active');
                                that.removeClass('detailsShowing');
                            }
                            // Show the item as needed
                            else {

                                if (hasTabs) {
                                    tabSet.children('ul:first-child').children('li').first().click();
                                }

                                // toggle aria state
                                that.attr('aria-expanded', false);

                                myButton.removeClass('show').addClass('hide');
                                itemDetails.addClass('active');
                                that.addClass('detailsShowing');
                            }
                        }
                    });
                }
                // open as many as you want
                else {
                    //nested if added for keyboard functionality of span icon
                    myButton.on('click keypress', function (event) {                  
                        if (event.type === "click" || (event.type === "keypress" && (event.which == 13 || event.which == 32))) {
                            if (myButton.hasClass('hide')) {
                                // toggle aria state
                                that.attr('aria-expanded', false);

                                myButton.removeClass('hide').addClass('show');
                                itemDetails.removeClass('active');
                                that.removeClass('detailsShowing');
                            }
                            else {
                                if (hasTabs) {
                                    tabSet.children('ul:first-child').children('li').first().click();
                                }

                                // toggle aria state
                                that.attr('aria-expanded', true);

                                myButton.removeClass('show').addClass('hide');
                                itemDetails.addClass('active');
                                that.addClass('detailsShowing');
                            }
                        }
                    });
                }
                sm.portal.keyboardNav.keyboardControl(that);
            }
            that.attr('data-processed', true);
        }
    }

    function detailedTable() {
        $('tbody.detailedTable > tr').each(function () {
            var that = $(this);

            if (!that.is('[data-processed]')) {
                sm.portal.ui.renderDetailedTableItem(that);
            }
        });
    }

    function renderDetailedTableItem(that)
    {
        if ($(that).is('tr')) {
            
            $(that).find('td>span.detailsIcon').on('click keypress', function (event) {
                if (event.type === "click" || (event.type === "keypress" && (event.which == 13))) {

                    var detailedTable = that.closest('tbody.detailedTable');
                    var myDetailsItem = that.next('.itemDetails');
                    var allButtons = detailedTable.find('.detailsIcon');
                    var myButton = that.find('.detailsIcon');;
                    var hideAction = myButton.hasClass('hide');

                    allButtons.removeClass('hide').addClass('show');
                    detailedTable.find('.itemDetails').removeClass('active');
                    detailedTable.find('.tr:not(.itemDetails)').removeClass('detailsShowing');

                    if (hideAction) {
                        myButton.removeClass('hide').addClass('show');
                        that.removeClass('detailsShowing');
                        myButton.attr('aria-expanded', false);
                    }
                    else {
                        myButton.attr('aria-expanded', true);
                        myDetailsItem.addClass('active');
                        myButton.removeClass('show').addClass('hide');
                        detailedTable.find('tr.detailsShowing').removeClass('detailsShowing');
                        that.addClass('detailsShowing');
                    }
                }
            });
        }
    }

    // Combo-Box Control binding
    function comboBox() {
        // Combo box Handler
        $('[data-combo-box]').not("[data-processed=true]").each(function () {
            $(this).attr('data-combobox-base-uri', _baseApiUri);
            $(this).combobox().attr('data-processed', true);
        });
    }

    // Adding our own scrollTo
    // Note 'el' must be a valid ID 
    function scrollTo(el) {
        $('html,body').animate({ scrollTop: $('#' + el).offset().top + 'px' }, 50, 'swing');
    }

    // unobtrusive scroll to
    function unobtrusiveScrollTop() {
        $('[data-scroll-top]').not('[data-scroll-top="processed"]').each(function () {
            var that = $(this);
            var destination = that.attr('data-scroll-top') == '' ? null : that.attr('data-scroll-top');

            if (destination == null) {
                destination = 'main_content';
            }

            if (destination != null && destination.length > 0) {
                // check if valid dom ID
                if ($('#' + destination).length > 0) {
                    destination = destination;
                }
                else {
                    //console.warn('SM Portal UI: No valid destination to scrollTo, scrolling to #main_content instead.');
                    destination = 'main_content';
                }
            }


            that.on('click', function () {
                if ($('.smStickySlideup.inYourFace').length > 0) {
                    // migrate this reference to slidepane (when ready)
                    sm.portal.ui.slidepane.closeAllSlideups(sm.portal.ui.scrollTo, destination);
                }
                else {
                    sm.portal.ui.scrollTo(destination);
                }
                sm.portal.keyboardNav.giveContentFocus('.smContentArea');
            });
        }).attr('data-scroll-top', 'processed');
    }

    //function needed to override the afo_widget_login post to allow for our own redirects
    function loginWidgetOverride() {
        $('[value="afo_user_login"]').each(function () {
            $(this).val('afo_user_login_trs');
        });
    }

    // common session/date toggling
    // TODO: Make this generic for easy reuse
    // swap classing for inline hide/show
    function toggleSessionStartDate() {
        $('#sessionStartDateToggle input[type="radio"]').not('[data-processed="true"]').on('change', function () {
            var selected = $('#sessionStartDateToggle input[type="radio"]:checked').length > 0 ? $('#sessionStartDateToggle input[type="radio"]:checked') : null;
            if (selected != null && selected.attr('id') == 'dateOption') {
                $('#sessionStartDateSelector').find('#SessionSection').hide();
                $('#sessionStartDateSelector').find('#DateSection').show();

            }
            else if (selected != null && selected.attr('id') == 'sessionOption') {
                $('#sessionStartDateSelector').find('#DateSection').hide();
                $('#sessionStartDateSelector').find('#SessionSection').show();
            }

        }).attr('data-processed', true);
    }

    function toggleSectionVisibility() {
        $('[data-toggle-section]').not('[data-processed="true"]').each(function () {
            var that = $(this);
            var statusIcon = $('<span class="icon detailsIcon"></span>');
            var mySection = $('[data-section="' + that.attr("data-toggle-section") + '"]');

            if (that.is('[data-default-open]')) {
                statusIcon.addClass('hide');
                that.append(statusIcon);
                mySection.show();
            }

            else {
                statusIcon.addClass('show');
                that.append(statusIcon);
                mySection.hide();
            }

            that.on('click', function () {
                if (mySection.is(':visible')) {
                    statusIcon.removeClass('hide').addClass('show');
                    mySection.hide();
                }
                else {
                    statusIcon.removeClass('show').addClass('hide');
                    mySection.show();
                }
            })

        }).attr('data-processed', true);
    }

    // Rounds up All Advanced Search Elements
    function getAdvancedSearchElements() {
        var o = {};

        o.keywordSearch = $('[data-keyword-search]');
        o.basicSearchBox = o.keywordSearch.find('[data-keyword-basic-input]');
        o.basicSearchBtn = o.keywordSearch.find('[data-keyword-basic-button]');
        o.advSearchActivation = o.keywordSearch.find('[data-adv-search-toggle]');
        o.expansionIcon = o.advSearchActivation.children('span.icon');
        o.searchArea = o.keywordSearch.siblings('[data-adv-search-fields]');

        return o;
    }

    // keyword (keyword) search
    function keywordSearch() {
        var se = sm.portal.ui.getAdvancedSearchElements();
        se.advSearchActivation.not('[data-processed="true"]').on('click', function () {
            var advanceSearchActivate = jQuery('.regAdvancedSearchActivation');
            if (se.expansionIcon.hasClass('closed')) {
                // if closed
                sm.portal.ui.openAdvancedSearch();
                advanceSearchActivate.attr('aria-expanded', 'true');
            }
            else {
                // if open
                sm.portal.ui.closeAdvancedSearch();
                advanceSearchActivate.attr('aria-expanded', 'false');
            }
        }).attr('data-processed', true);
    }

    // Opens Advanced Search
    function openAdvancedSearch() {
        se = sm.portal.ui.getAdvancedSearchElements();

        // Activate the button
        se.advSearchActivation.addClass('active');

        // Disable basic search
        se.basicSearchBox.val('');
        se.basicSearchBox.attr('placeholder', sm.portal.utility.getResourceValue('UsingAdvancedSearch'));
        se.basicSearchBox.attr('disabled', 'disabled');
        se.basicSearchBtn.attr('disabled', 'disabled');

        // Show advanced search
        se.expansionIcon.removeClass('closed').addClass('open');
        se.searchArea.addClass('active').slideDown('fast');
    }

    // Closes Advanced Search
    function closeAdvancedSearch() {
        se = sm.portal.ui.getAdvancedSearchElements();

        // Deactivate the button
        se.advSearchActivation.removeClass('active');
        // Hide Advanced Search
        se.expansionIcon.removeClass('open').addClass('closed');
        se.searchArea.removeClass('active').slideUp('fast');
        // Enable Basic Search
        se.basicSearchBox.attr('placeholder', sm.portal.utility.getResourceValue('CourseKeywordSearch'));
        se.basicSearchBox.removeAttr('disabled');
        se.basicSearchBtn.removeAttr('disabled');
    }

    // EVAL ALTERNATIVE - FASTER & SAFER
    // USAGE: sm.portal.ui.executeFunctionByName('someFunctionHere.NameSpaced.Is.fine', window, args');
    // Change context from 'window' by passing alternative
    function executeFunctionByName(functionName, context, args) {
        if (functionName != null && functionName != 'undefined' && functionName != '') {
            var args = [].slice.call(arguments).splice(2);
            var namespaces = (typeof functionName == 'string') ? functionName.split(".") : null;

            if (namespaces != null) {
                var func = namespaces.pop();

                for (var i = 0; i < namespaces.length; i++) {
                    context = context[namespaces[i]];
                }
                return context[func].apply(context, args);
            }
        }
    }

    // Delete or create ThirdPartyNotice cookie to determine if to show third party notice
    function setThirdPartyNotice() {

        var isChecked = $('#doNotShowThirdParty').is(":checked");

        if (isChecked) {
            // add the cookie, when present, prevents dialog from displaying  
            setCookie("_ThirdPartyNotice",1,999);
        } else {
            // delete the cookie
            setCookie("_ThirdPartyNotice", 1, -1);
        }
    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function setSessionCookie(cname, cvalue) {
        document.cookie = cname + "=" + cvalue + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

     function simpleContainerToggle() {
        $('[data-toggle-container]').not('[data-simple-container-toggle-processed="true"]').each(function () {
            var clickable = $(this);
            var icon = clickable.children('span.icon').length > 0 ? clickable.children('span.icon') : null;
            var relatedContainer = $('[data-toggleable-container="' + clickable.attr('data-toggle-container') + '"]');

            // create and append icon if not already there
            if (icon === null) {
                icon = $('<span class="icon open"></span>');
                clickable.append(icon);
            }

            if (typeof relatedContainer === 'object' && relatedContainer.length > 0) {

                clickable.on('click', function (event) {

                    event.preventDefault();

                    if (relatedContainer.is('.showing')) {
                        relatedContainer.removeClass('showing');
                        icon.removeClass('open').addClass('close');
                    }
                    else {
                        relatedContainer.addClass('showing');
                        icon.removeClass('close').addClass('open');
                    }
                });
            }
        }).attr('data-simple-container-toggle-processed', true);
    }

    /*********************************************************************************/
    /*   TABLE WITH PAGINATION                                                       */
    /*********************************************************************************/
    
    /**
      * @param {String} displayName Name that is presented to user.
      * @param {String=} fieldName Field name in 'RowData'.
      * @param {Boolean} isSortable Is possible sorting by this field.
      * @param {ColumnDataFormatters=} dataFormatter [**default: ColumnDataFormatters.Simple**] Format data for display.
      * @param {String=} htmlElement [**default: 'span'**] For text or icon use 'span'. For button use 'button'. For checkbox use 'checkbox'.
      * @param {function(Object, ColumnDefinition, Object):void=} onClickHandler [**default: NULL**] Invoked after click on single cell. First argument is 'RowData'. Last argument is 'Event'.
      * @param {String|function(Object, ColumnDefinition):String=} customClass [**default: NULL**] Invoked for every cell to set specified style. First argument is 'RowData'.
      * @param {String=} staticContent [**default: NULL**] Use static content for cell instead of 'RowData'.
      */
    function ColumnDefinition(displayName, fieldName, isSortable, dataFormatter, htmlElement, onClickHandler, customClass, staticContent) {
        this.DisplayName = displayName;
        this.FieldName = fieldName;
        this.IsSortable = isSortable;
        this.DataFormatter = dataFormatter != null ? dataFormatter : ColumnDataFormatters.Simple;
        this.HtmlElement = htmlElement != null ? htmlElement : 'span';
        this.OnClickHandler = onClickHandler;
        this.CustomClass = customClass;
        this.StaticContent = staticContent;
    }

    
    /**
      * @param {String} tableId Unique table id.
      * @param {String} header Table header.
      * @param {function(TableDataLoadParameters, function(TableData), function(String))} dataLoadHandler Second parameter is success callback. Third parameter is error callback.
      * @param {ColumnDefinition[]} columnDefinitions Column definitions.
      * @param {Boolean} paginationEnabled Enabled pagination.
      * @param {Number} pageSize Number, greater than 0.
      * @param {sm.portal.utility.Sorting} defaultSorting Default sorting.
      * @param {String} filterTemplateId Filter template id.
      * @param {object} filterViewModel Filter view model.
      */
    function TableConfiguration(tableId, header, dataLoadHandler, columnDefinitions, paginationEnabled, pageSize, defaultSorting, filterTemplateId, filterViewModel, settingsTemplateId, settingsViewModel) {
        this.TableId = tableId;
        this.Header = ko.observable(header);
        this.DataLoadHandler = dataLoadHandler;
        this.ColumnDefinitions = columnDefinitions;
        this.PaginationEnabled = paginationEnabled;
        this.PageSize = paginationEnabled ? pageSize : -1;
        this.DefaultSorting = defaultSorting;
        this.FilteringEnabled = !sm.portal.utility.isNullOrEmpty(filterTemplateId);
        this.FilterTemplateId = filterTemplateId;
        this.FilterViewModel = filterViewModel;
        this.SettingsEnabled = !sm.portal.utility.isNullOrEmpty(settingsTemplateId);
        this.SettingsTemplateId = settingsTemplateId;
        this.SettingsViewModel = settingsViewModel;
    }


    function ColumnDataFormatters() { }
    /** @description Return empty string when input data is NULL or just input data in every other case. */
    ColumnDataFormatters.Simple = function (data) {
        if (data == null) {
            return '';
        }

        return data;
    };
    /** @description Return value in format '0.00' (with 2 decimal places) or empty string with input data is NULL. */
    ColumnDataFormatters.Money = function (data) {
        if (data == null) {
            return '';
        }

        return parseFloat(data).toFixed(2);
    };
    /** @description Return only date without time in browser locale format or empty string with input data is NULL. */
    ColumnDataFormatters.LocaleDate = function (data) {
        if (data == null) {
            return '';
        }
        if(window.u4sm_canada_enabled){
            return moment(new Date(data)).format("YYYY/MM/DD"); 
        }   
        else{
            return new Date(data).toLocaleDateString();
        }
    };

    /** @description Return only date without time in browser locale format or empty string with input data is NULL. */
    ColumnDataFormatters.LocaleDateTime = function (data) {
        if (data == null) {
            return '';
        }

        var date = new Date(data);

        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    };

    /** @description Return value in format '0.00%' (with 2 decimal places) or empty string with input data is NULL. */
    ColumnDataFormatters.Percent = function (data) {
        if (data == null) {
            return '';
        }

        return parseFloat(data).toFixed(2) + '%';
    };

    /** @description Return translated value or empty string with input data is NULL. */
    ColumnDataFormatters.Translation = function (data) {
        if (data == null) {
            return '';
        }

        return sm.portal.utility.getResourceValue(data);
    };

    /**
      * @param {Object[]} rows Rows.
      * @param {Number} totalRowsCount Total rows count. Should be greater or equal 0.
      */
    function TableData(rows, totalRowsCount) {
        this.Rows = rows;
        this.TotalRowsCount = totalRowsCount;
    }


    function TableDataLoadParameters() {
        var self = this;

        /** @property {Number=} Top Top */
        this.Top = null;

        /** @property {Number=} Skip Skip */
        this.Skip = null;

        /** @property {sm.portal.utility.Sorting=} Sorting Sorting */
        this.Sorting = null;

        /** @property {sm.portal.utility.FilterDefinition[]} Filters Filters */
        this.Filters = [];
    }

    function FilterViewModelBase() {
        var self = this;

        // set by TableViewModel
        this.TableHeader = ko.observable();
        this.ApplyFiltersTrigger = null;
        this.ClearFiltersTrigger = null;

        this.IsInitialized = false;

        this.Initialize = function(tableHeader, applyFiltersTrigger, clearFiltersTrigger) {
            self.ApplyFiltersTrigger = applyFiltersTrigger;
            self.ClearFiltersTrigger = clearFiltersTrigger;

            self.TableHeader(tableHeader());
            tableHeader.subscribe(function(header) { self.TableHeader(header); });

            self.IsInitialized = true;
        }

        this.ApplyFiltersClick = function(elem) {
            var filters = [];

            $.each(self.Configuration, function(_, config) {
                    var value = self[config.ObservableFieldName]();
                    if (!sm.portal.utility.isNullOrEmpty(value)) {
                        filters.push(new sm.portal.utility.FilterDefinition(config.FilterFieldName, config.FilterOperator, value));
                    }
                });

            self.ApplyFiltersTrigger(filters);
            element = elem().split(" ")[0];
            jQuery('.' + element).focus();
            jQuery('.' + element).removeClass(element);
        };

        this.ClearFiltersClick = function(elem) {
            self.ClearFiltersTrigger();
            element = elem().split(" ")[0];
            jQuery('.' + element).focus();
            jQuery('.' + element).removeClass(element);
        };

        this.OnOpen = function(appliedFilters) {
            $.each(self.Configuration, function(_, config) {
                var filters = $.grep(appliedFilters, function(f) { return f.FieldName === config.FilterFieldName && f.Operator === config.FilterOperator });
                var filterValue = filters.length === 1 ? filters[0].Value : undefined;
                self[config.ObservableFieldName](filterValue);
            });
        };
    }

    function SettingsViewModelBase() {
        var self = this;

        this.TableHeader = ko.observable();
        this.ApplySettingsTrigger = null;
        this.ClearSettingsTrigger = null;

        this.IsInitialized = false;

        this.Initialize = function (tableHeader, applySettingsTrigger, clearSettingsTrigger) {
            self.ApplySettingsTrigger = applySettingsTrigger;
            self.ClearSettingsTrigger = clearSettingsTrigger;

            self.TableHeader(tableHeader());
            tableHeader.subscribe(function (header) { self.TableHeader(header); });

            self.IsInitialized = true;
        };

        this.ApplySettingsClick = function(elem) {
            var settings = {};

            $.each(self.Configuration, function (_, config) {
                var value = self[config.FieldName]();
                settings[config.FieldName] = value;
            });

            self.ApplySettingsTrigger(settings);
            element = elem().split(" ")[0];
            jQuery('.' + element).focus();
            jQuery('.' + element).removeClass(element);
        };

        this.ClearSettingsClick = function(elem) {
            self.ClearSettingsTrigger();
            element = elem().split(" ")[0];
            jQuery('.' + element).focus();
            jQuery('.' + element).removeClass(element);
        };

        this.OnOpen = function (appliedSettings) {
            $.each(self.Configuration, function (_, config) {
                var value = appliedSettings[config.FieldName];
                self[config.FieldName](value);
            });
        };
    }
    
    /**
     * @param {TableConfiguration} configuration Configuration
     */
    function TableViewModel(configuration) {
        var self = this;

        /* PROPERTIES */
        this.Configuration = configuration;
        this.Rows = ko.observableArray([]);
        this.TotalRowsCount = ko.observable(0);
        this.PageNumber = ko.observable(0);
        this.Sorting = ko.observable(configuration.DefaultSorting);
        this.AppliedFilters = ko.observable([]);
        this.FilterVisible = ko.observable(false);
        this.AppliedSettings = ko.observable({});
        this.SettingsVisible = ko.observable(false);
        /* END OF PROPERTIES */

        /* DATA LOADING */
        this.Initialize = function () {
            self.InitializeFiltering();
            self.InitializeSettings();
            self.LoadData(0, self.Sorting());
        }

        this.LoadData = function (pageNumber, sorting) {
            var dataLoadParameters = new TableDataLoadParameters();
            dataLoadParameters.Sorting = sorting;
            
            if (self.Configuration.PaginationEnabled) {
                dataLoadParameters.Skip = pageNumber * self.Configuration.PageSize;
                dataLoadParameters.Top = self.Configuration.PageSize;
            }

            if (self.Configuration.FilteringEnabled) {
                dataLoadParameters.Filters = self.AppliedFilters();
            }

            if (self.Configuration.SettingsEnabled) {
                dataLoadParameters.Settings = self.AppliedSettings();
            }

            self.BlockTable();

            var successCallback = function (tableData) {
                self.Rows(tableData.Rows);
                self.TotalRowsCount(tableData.TotalRowsCount);
                self.PageNumber(pageNumber);
                self.Sorting(sorting);
                self.UnblockTable();
            };

            var errorCallback = function (error) {
                self.UnblockTable();
            };

            self.Configuration.DataLoadHandler(dataLoadParameters, successCallback, errorCallback);
        };
        /* END OF DATA LOADING */

        /* SORTING */
        this.SortBy = function (columnDefinition) {
            if (event.type === "click" || (event.type === "keypress" && (event.which == 13 || event.which == 32))) {
                if (!columnDefinition.IsSortable) {
                    return;
                }

                var isSortingByDifferentColumn = self.Sorting().FieldName !== columnDefinition.FieldName;
                if (isSortingByDifferentColumn) {
                    var sorting = new sm.portal.utility.Sorting(columnDefinition.FieldName, sm.portal.utility.SortingDirection.Asc);
                    self.LoadData(0, sorting);
                } else {
                    var invertedDirection = self.Sorting().Direction === sm.portal.utility.SortingDirection.Asc ? sm.portal.utility.SortingDirection.Desc : sm.portal.utility.SortingDirection.Asc;
                    var sorting = new sm.portal.utility.Sorting(self.Sorting().FieldName, invertedDirection);
                    self.LoadData(0, sorting);
                }
            }
        };

        this.ResetSorting = function () {
            this.LoadData(0, self.Configuration.DefaultSorting);
        };
        /* END OF SORTiNG */

        /* PAGINATION */
        this.UIPresentedRowsFrom = ko.pureComputed(function () {
            return self.TotalRowsCount() > 0 ? self.PresentedRowsFrom() + 1 : 0;
        });

        this.PresentedRowsFrom = ko.pureComputed(function () {
            return self.PageNumber() * self.Configuration.PageSize;
        });

        this.PresentedRowsTo = ko.pureComputed(function () {
            return self.PresentedRowsFrom() + self.Rows().length;
        });

        this.CanGoToNextPage = ko.pureComputed(function () {
            return self.PresentedRowsTo() < self.TotalRowsCount();
        });

        this.GoToNextPage = function () {
            var nextPageNumber = self.PageNumber() + 1;
            self.LoadData(nextPageNumber, self.Sorting());
        };

        this.CanGoToPreviousPage = ko.pureComputed(function () {
            return self.PageNumber() > 0;
        });

        this.GoToPreviousPage = function () {
            var previousPageNumber = self.PageNumber() - 1;
            self.LoadData(previousPageNumber, self.Sorting());
        };

        this.CanGoToFirstPage = ko.pureComputed(function () {
            return self.PageNumber() > 0;
        });

        this.GoToFirstPage = function () {
            self.LoadData(0, self.Sorting());
        };

        this.CanGoToLastPage = ko.pureComputed(function () {
            return self.PresentedRowsTo() < self.TotalRowsCount();
        });

        this.GoToLastPage = function () {
            var lastPageNumber = Math.ceil(self.TotalRowsCount() / self.Configuration.PageSize) - 1;
            self.LoadData(lastPageNumber, self.Sorting());
        };
        /* END OF PAGINATION */

        /* EVENTS HANDLING */
        this.OnClick = function (rowData, columnDefinition, event) {
            if (columnDefinition.OnClickHandler != null) {
                return columnDefinition.OnClickHandler(rowData, columnDefinition, event);
            }
        };
        /* END OF EVENTS HANDLING */

        /* UI HELPERS */
        this.CustomClass = function (rowData, columnDefinition) {
			if (columnDefinition.CustomClass != null) {
				if ($.type(columnDefinition.CustomClass) === 'string') {
					return columnDefinition.CustomClass;
				} else {
					return columnDefinition.CustomClass(rowData, columnDefinition);
				}
            }

            return null;
        };

        this.BlockTable = function () {
            self.$Table().block();
        };

        this.UnblockTable = function () {
            self.$Table().unblock();
        };

        this.$Table = function() {
            return $('#' + self.Configuration.TableId);
        };
        /* END OF UI HELPERS */

        /* FILTERING */
        this.InitializeFiltering = function() {
            if (self.Configuration.FilteringEnabled && !self.Configuration.FilterViewModel.IsInitialized) {
                self.Configuration.FilterViewModel.Initialize(self.Configuration.Header, self.ApplyFilter, self.ClearFilter);
            }
        };

        this.ToggleFilter = function(event, header) {
            if (event.type === "click" || (event.type === "keypress" && (event.which == 13 || event.which == 32))) {
                if (!self.FilterVisible()) {
                    self.Configuration.FilterViewModel.OnOpen(self.AppliedFilters().slice());
                }

                self.FilterVisible(!self.FilterVisible());
                jQuery('.filterVisible').modalTabbing();
                jQuery(event.currentTarget).addClass(header().split(" ")[0]);
            }            
        };

        this.ClearFilter = function() {
            var needRefresh = self.AppliedFilters().length > 0;

            self.AppliedFilters([]);
            self.FilterVisible(false);

            if (needRefresh) {
                self.Initialize();
            }
        };

        this.ApplyFilter = function (filters) {
            self.AppliedFilters(filters);
            self.FilterVisible(false);

            self.Initialize();
        };

        this.FilterButtonStyle = ko.pureComputed(function () {
            if (self.FilterVisible()) {
                return 'opened';
            }

            return self.AppliedFilters().length > 0 ? 'applied' : 'notApplied';
        });
        /* END OF FILTERING */

        /* SETTINGS */
        this.InitializeSettings = function () {
            if (self.Configuration.SettingsEnabled && !self.Configuration.SettingsViewModel.IsInitialized) {
                self.Configuration.SettingsViewModel.Initialize(self.Configuration.Header, self.ApplySettings, self.ClearSettings);
            }
        };

        this.ApplySettings = function (settings) {
            self.AppliedSettings(settings);
            self.SettingsVisible(false);
            self.Initialize();
        };

        this.ClearSettings = function () {
            var needRefresh = Object.keys(self.AppliedSettings()).length > 0;

            self.AppliedSettings({});
            self.SettingsVisible(false);

            if (needRefresh) {
                self.Initialize();
            }
        };

        this.ToggleSettings = function (event, header) {
            if (event.type === "click" || (event.type === "keypress" && (event.which == 13 || event.which == 32))) {
                if (!self.SettingsVisible()) {
                    self.Configuration.SettingsViewModel.OnOpen(self.AppliedSettings());
                }

                self.SettingsVisible(!self.SettingsVisible());
                jQuery('.settingsVisible').modalTabbing();
                jQuery(event.currentTarget).addClass(header().split(" ")[0]);
            }
        };

        this.SettingsButtonStyle = ko.pureComputed(function () {
            if (self.SettingsVisible()) {
                return 'opened';
            }

            return Object.keys(self.AppliedSettings()).length > 0 ? 'applied' : 'notApplied';
        });
        /* ENF OF SETTINGS */
    }

    function InformationMessageViewModel() {
        self.Header = ko.observable();
        self.Messages = ko.observableArray();

        self.ShowMessages = ko.computed(function () {
            return self.Messages().length > 0;
        });

        return self;
    }

    $.extend(true, sm.portal.ui, {
        initPage: initPage,
        readyPage: readyPage,
        resizePage: resizePage,
        loadingIndicator: loadingIndicator,
        successIndicator: successIndicator,
        clearUpload: clearUpload,
        tabs: tabs,
        responsiveTabs: responsiveTabs,
        getTotalTabWidth: getTotalTabWidth,
        checkTabOverflow: checkTabOverflow,
        responsiveTabMenu: responsiveTabMenu,
        responsiveTabSync: responsiveTabSync,
        lightBox: lightBox,
        lightBoxLogout: lightBoxLogout,
        sponsorLightBox: sponsorLightBox,
        loadOrCreateLightbox: loadOrCreateLightbox,
        resizeLightbox: resizeLightbox,
        closeLightbox: closeLightbox,
        closeSponsorLightbox: closeSponsorLightbox,
        removeLightbox: removeLightbox,
        syntaxHighlight: syntaxHighlight,
        hideElements: hideElements,
        itemMenu: itemMenu,
        tableOverflow: tableOverflow,
        detailedList: detailedList,
        subDetailedList: subDetailedList,
        childOfSubDetailedList: childOfSubDetailedList,
        detailedTable: detailedTable,
        renderDetailedListItem: renderDetailedListItem,
        renderDetailedTableItem: renderDetailedTableItem,
        comboBox: comboBox,
        scrollTo: scrollTo,
        unobtrusiveScrollTop: unobtrusiveScrollTop,
        loginWidgetOverride: loginWidgetOverride, //NEEDED?
        toggleSessionStartDate: toggleSessionStartDate,
        toggleSectionVisibility: toggleSectionVisibility,
        keywordSearch: keywordSearch,
        getAdvancedSearchElements: getAdvancedSearchElements,
        openAdvancedSearch: openAdvancedSearch,
        closeAdvancedSearch: closeAdvancedSearch,
        executeFunctionByName: executeFunctionByName,
        setThirdPartyNotice: setThirdPartyNotice,
        setCookie: setCookie,
        setSessionCookie: setSessionCookie,
        getCookie: getCookie,
        simpleContainerToggle: simpleContainerToggle,
        createProfileImageEditor: createProfileImageEditor,
        RecordPagingViewModel: RecordPagingViewModel,
        ColumnDefinition: ColumnDefinition,
        TableConfiguration: TableConfiguration,
        ColumnDataFormatters: ColumnDataFormatters,
        TableData: TableData,
        TableDataLoadParameters: TableDataLoadParameters,
        optionalFeatureToggle: optionalFeatureToggle,
        TableViewModel: TableViewModel,
        FilterViewModelBase: FilterViewModelBase,
        InformationMessageViewModel: InformationMessageViewModel,
        SettingsViewModelBase: SettingsViewModelBase,
        uploadDocument: uploadDocument,
    });

})(jQuery);

// page wire up SM Events 
jQuery(document).ready(function () {
    jQuery(window).onDelayed('resize', 100, function () {
        sm.portal.ui.resizePage();
    });
    sm.portal.ui.initPage();
});

// Extending jQuery to Add OnDelayed event
(function ($) {
    $.fn.onDelayed = function (eventName, delayInMs, callback) {
        var _timeout;
        this.on(eventName, function (e) {
            if (!!_timeout) {
                clearTimeout(_timeout);
                //console.log('timer being re-set: ' + eventName);
            } else {
                // console.log('timer being set for the first time: ' + eventName);
            }
            _timeout = setTimeout(function () {
                callback(e);
            }, delayInMs);
        });
    };
})(jQuery);


(function ($) {
    $.fn.cleanWhitespace = function () {
        this.contents().filter(function () {
            return (this.nodeType == 3 && !/\S/.test(this.nodeValue));
        }).remove();
        return this;
    };
})(jQuery);

//Optional parameter includeMargin is used when calculating outer dimensions  
(function ($) {
    $.fn.getHiddenDimensions = function (includeMargin) {
        var $item = this,
            props = { position: 'absolute', visibility: 'hidden', display: 'block' },
            dim = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 },
            $hiddenParents = $item.parents().andSelf().not(':visible');

        includeMargin = (includeMargin == null) ? false : includeMargin;

        var oldProps = [];
        $hiddenParents.each(function () {
            var old = {};

            for (var name in props) {
                old[name] = this.style[name];
                this.style[name] = props[name];
            }

            oldProps.push(old);
        });

        dim.width = $item.width();
        dim.outerWidth = $item.outerWidth(includeMargin);
        dim.innerWidth = $item.innerWidth();
        dim.height = $item.height();
        dim.innerHeight = $item.innerHeight();
        dim.outerHeight = $item.outerHeight(includeMargin);

        $hiddenParents.each(function (i) {
            var old = oldProps[i];
            for (var name in props) {
                this.style[name] = old[name];
            }
        });

        return dim;
    };
}(jQuery));
